import { render } from "./ItemProfileListItem.vue?vue&type=template&id=1f3d2c4e&scoped=true"
import script from "./ItemProfileListItem.vue?vue&type=script&lang=ts"
export * from "./ItemProfileListItem.vue?vue&type=script&lang=ts"

import "./ItemProfileListItem.vue?vue&type=style&index=0&id=1f3d2c4e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1f3d2c4e"

export default script